import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import { GET_VERTICAL_GLOBAL_MERTICES, GET_VERTICAL_GLOBAL_MERTICES_ERROR, GET_VERTICAL_GLOBAL_MERTICES_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getVerticalGlobalMetrices({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/metrics/global/verticals/${payload?.verticalId}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParam,
    });

    if (response.status === 200) {
      yield put({
        type: GET_VERTICAL_GLOBAL_MERTICES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_VERTICAL_GLOBAL_MERTICES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VERTICAL_GLOBAL_MERTICES_ERROR, payload: error });
  }
}

export function* watchGetVerticalGlobalMetrices() {
  yield takeEvery(GET_VERTICAL_GLOBAL_MERTICES, getVerticalGlobalMetrices);
}

function* getVerticalGlobalMetricesSaga() {
  yield all([fork(watchGetVerticalGlobalMetrices)]);
}

export default getVerticalGlobalMetricesSaga;
